import Link from "next/link";
import CartButton from "@/components/ui/CartButton";
import UserDropdown from "@/components/ui/UserDropdown";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { isAuthenticated, authReady, openAuthModal, user } = useAuth();
  const isAdmin = String(user?.role || "").toUpperCase() === "ADMIN";

  return (
    <header className="sticky top-0 z-30 border-b border-primary-light bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-4 md:px-6 md:py-5">
        <Link href="/" className="block">
          <p className="font-cormorant text-2xl font-semibold text-zinc-900">Dream Wedding</p>
          <p className="text-xs uppercase tracking-[0.3em] text-primary">Realize your dream</p>
        </Link>

        <div className="flex items-center gap-6">
          <div className="relative flex items-center justify-end h-11" suppressHydrationWarning>
            {!authReady ? (
              <div className="flex items-center justify-center w-11 h-11 rounded-full border border-primary-light bg-primary/5 text-primary">
                <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            ) : isAuthenticated ? (
              <div className="animate-[fadeIn_0.4s_ease-in-out]">
                <UserDropdown />
              </div>
            ) : (
              <button
                type="button"
                onClick={() => openAuthModal("login")}
                className="group relative flex h-11 items-center overflow-hidden rounded-full border border-primary bg-primary text-sm font-semibold text-white transition-all hover:bg-transparent! hover:text-primary! animate-expand-btn cursor-pointer"
              >
                <span className="whitespace-nowrap px-5 animate-slide-text flex items-center gap-2">
                  Get started <span className="text-xl leading-none">&rarr;</span>
                </span>
              </button>
            )}
          </div>
          {isAuthenticated && isAdmin && (
            <Link
              href="/admin/orders"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-primary-light bg-primary/5 text-primary transition hover:border-primary hover:bg-primary hover:text-white"
              title="Admin Orders"
              aria-label="Admin Orders"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 3h18v4H3z" />
                <path d="M5 7v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7" />
                <path d="M9 12h6" />
                <path d="M9 16h4" />
              </svg>
            </Link>
          )}
          <CartButton />
        </div>
      </div>
    </header>
  );
}
